// extracted by mini-css-extract-plugin
export default {"popupDetail":"style_popupDetail__jgMz4","title":"style_title__nAOY7","time":"style_time__EzEmi","content":"style_content__EQuJz"};